import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BreadcrumbsComponent } from './components/breadcrumbs/breadcrumbs.component';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ListComponent } from './components/list/list.component';
import { ClickOutsideDirective } from './directives/click-outside/click-outside.directive';
import { SidebarDirective } from './directives/sidebar/sidebar.directive';
import { BackdropDirective } from './directives/backdrop/backdrop.directive';
import { TitleDirective } from './directives/title/title.directive';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { LoadingIndicatorComponent } from './components/loading-indicator/loading-indicator.component';
import { PageLayoutContentDirective } from './directives/page-layout/page-layout-content.directive';
import { PageLayoutDirective } from './directives/page-layout/page-layout.directive';
import { PageLayoutHeaderDirective } from './directives/page-layout/page-layout-header.directive';
import { AppCard, AppCardActions, AppCardContent, AppCardHeader, AppCardHeaderActions, AppCardHeaderSubTitle, AppCardHeaderTitle } from './components/card/card.component';
import { ScrollbarComponent } from './components/scrollbar/scrollbar.component';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatRippleModule } from '@angular/material/core';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatMenuModule } from '@angular/material/menu';
import { MatRadioModule } from '@angular/material/radio';
import { MaterialModule } from './utils/material-components.module';
import { ListSearchButtonComponent } from './components/list-search-button/list-search-button.component';
import { ListSearchButtonDatesComponent } from './components/list-search-button-dates/list-search-button-dates.component';
import { ListSearchDataReportComponent } from './components/list-search-data-report/list-search-data-report.component';
import { ListSearchDatesComboReportComponent } from './components/list-search-dates-combo-report/list-search-dates-combo-report.component';
import { VarDirective } from './directives/ng-var/ng-var.directive';

const cardComponents = [
  AppCard,
  AppCardHeader,
  AppCardHeaderTitle,
  AppCardHeaderSubTitle,
  AppCardHeaderActions,
  AppCardContent,
  AppCardActions
];

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    MatProgressBarModule,
    MaterialModule,
    ReactiveFormsModule
  ],
  declarations: [
    BreadcrumbsComponent,
    ListComponent,
    ListSearchButtonComponent,
    ClickOutsideDirective,
    SidebarDirective,
    BackdropDirective,
    TitleDirective,
    VarDirective,
    LoadingIndicatorComponent,
    PageLayoutContentDirective,
    PageLayoutDirective,
    PageLayoutHeaderDirective,
    ...cardComponents,
    ScrollbarComponent,
    ListSearchButtonDatesComponent,
    ListSearchDataReportComponent,
    ListSearchDatesComboReportComponent,
  ],
  exports: [
    BreadcrumbsComponent,
    ListComponent,
    ListSearchButtonComponent,
    ClickOutsideDirective,
    SidebarDirective,
    BackdropDirective,
    TitleDirective,
    VarDirective,
    LoadingIndicatorComponent,
    PageLayoutContentDirective,
    PageLayoutDirective,
    PageLayoutHeaderDirective,
    ...cardComponents,
    ScrollbarComponent,
    
    FlexLayoutModule,
    MatInputModule,
    MatIconModule,
    MatButtonModule,
    MatRippleModule,
    MatSlideToggleModule,
    MatCheckboxModule,
    MatRadioModule,
    MatMenuModule,
    ListSearchButtonDatesComponent,
    ListSearchDataReportComponent,
    ListSearchDatesComboReportComponent
  ]
})
export class NitroModule { }
